import {ru} from './ru'

export const jpayLocalization = {
  ru,
}
